(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker-top-buttons.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker-top-buttons.js');

'use strict';

const {
  memoFetchSpan
} = svs.lyckoplatsen.utils.page_result;
const {
  selectedSpanResultsAtom,
  shouldShowIntervalAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  useAtom
} = jotai;
const Button = svs.ui.ReactButton;
const {
  useHistory
} = ReactRouterDOM;
const {
  CONSTANTS: {
    RESULT_INTERVALS
  }
} = svs.lyckoplatsen.components.shared_constants;
const INTERVAL_PATHS = {
  30: RESULT_INTERVALS.THIRTY_DAYS,
  183: RESULT_INTERVALS.SIX_MONTHS,
  365: RESULT_INTERVALS.ONE_YEAR
};
const DrawPickerTopButtons = _ref => {
  let {
    handleClose
  } = _ref;
  const [spawnResults, setSpanResults] = useAtom(selectedSpanResultsAtom);
  const [shouldShowInterval, setShouldShowInterval] = useAtom(shouldShowIntervalAtom);
  const history = useHistory();
  const setResultsSpan = async days => {
    const spanResults = await memoFetchSpan(days);
    setSpanResults(spanResults);
    setShouldShowInterval(true);
    history.push("/resultat/".concat(INTERVAL_PATHS[days]));
    handleClose === null || handleClose === void 0 || handleClose();
  };
  let days = 0;
  if (spawnResults !== null && spawnResults !== void 0 && spawnResults.span) {
    const startDate = new Date(spawnResults.span.startDate);
    const endDate = new Date(spawnResults.span.endDate);
    days = dateFns.differenceInDays(endDate, startDate);
  }
  return React.createElement("div", {
    className: "lp-draw-picker-top-buttons padding-1"
  }, React.createElement("div", {
    className: "button-label"
  }, "SENASTE"), React.createElement("div", {
    className: "buttons-wrapper"
  }, React.createElement(Button, {
    inverted: shouldShowInterval && days === 30,
    transparent: !shouldShowInterval || days !== 30,
    onClick: () => setResultsSpan(30)
  }, "30 dagar"), React.createElement(Button, {
    inverted: shouldShowInterval && days === 183,
    transparent: !shouldShowInterval || days !== 183,
    onClick: () => setResultsSpan(183)
  }, "6 m\xE5nader"), React.createElement(Button, {
    inverted: shouldShowInterval && days === 365,
    transparent: !shouldShowInterval || days !== 365,
    onClick: () => setResultsSpan(365)
  }, "1 \xE5r")));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  DrawPickerTopButtons
});

 })(window);